
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import eleCalendar from "ele-calendar";
import "./eleCalendarStyle/vue-calendar.css"; //引入css 
@Component({
  name: "nvEleCalendar",
  components: {
    eleCalendar
  },
})
export default class nvEleCalendar extends BaseVue {
  @Prop({ default: () => [] }) data!: any; //显示的数据
  @Prop({ default: () => "date" }) prop!: String; //对应日期字段名
  @Prop({ default: () => true}) currentmonth!: Boolean; //高亮选中日期
  @Prop({ default: () => undefined }) renderContent: any | undefined;   //内容区的渲染 Function
  @Prop({ default: () => undefined }) disabledDate: any | undefined;   //禁用点击日期
  mounted() {
    this.ref('calendarRef').handleDatePick(new Date())
  }
  pick(data,event,row,dome){
    this.$emit("pick",data,event,row,dome)
  }
  dateChange(data){
    console.log(data)
    this.$emit("date-change",data)
  }
  selectEvent(val,selectDom){
    this.$emit("select",val,selectDom)
  }
}
